import backgroundLogin from "../../img/background_login.png";
import favicon from "../../img/favicon.png";
import logoPrincipal from "../../img/logo_principal.png";
import logoToolbar from "../../img/logo_toolbar.png";

import { getDomainThemeData, getUserThemeData } from "./api";

export const DEFAULT_THEME = {
    primary_color: "#064635",
    primary_text_color: "#fff",
    secondary_color: "#1cb987",
    secondary_text_color: "#fff",
    login_logo: `url(${logoPrincipal})`,
    login_background_image: `url(${backgroundLogin})`,
    toolbar_image: `url(${logoToolbar})`,
    favicon: `${favicon}`,
};

export const setUserTheme = async () => {
    let theme = DEFAULT_THEME;

    const domainThemeData = await getDomainThemeData(window.location.hostname);

    if (domainThemeData) {
        theme = domainThemeData;
    }

    const userThemeData = await getUserThemeData();

    if (userThemeData) {
        theme = userThemeData;
    }

    const root = $(":root");

    root.css({
        "--dx-theme-primary-color": theme.primary_color,
        "--dx-theme-primary-text-color": theme.primary_text_color,
        "--dx-theme-secondary-color": theme.secondary_color,
        "--dx-theme-secondary-text-color": theme.secondary_text_color,
        "--dx-theme-logo-login": theme.login_logo,
        "--dx-theme-imagem-bg": theme.login_background_image,
        "--dx-theme-logo-toolbar": theme.toolbar_image,
    });

    let link = document.querySelector("link[rel~='icon']");
    if (link) link.href = theme.favicon;
};
